import { Consumer as AWConsumer } from 'lib/amwell/sdk/types';
import { Gender } from 'lib/amwell/sdk/enums';

// Types
export type Consumer = AWConsumer;

// Enums
export { Gender };

// Action Types
export interface GetVisitTokenPayload {
  dfdOnly: boolean;
  possibleCCEmailAddr?: string;
  ccpassword?: string;
  error?: string;
  appType?: string;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface LoginWithTokenPayload {
  visitToken: string;
}

export interface UpdateConsumerLegalResidencePayload {
  stateCode: string;
  countryCode?: string;
}

export interface RequestPasswordResetPayload {
  email: string;
  lastName: string;
  dob: Date | string;
}
